<template>
  <transition>
    <section class="comment_area opinion_search"
      :class="state.showCommentList ? '' : 'active'"
      id="board-comment">
      <h2 class="hide">{{$i18nUtil.trans("message.BoardComment.001","의견 작성 레이어")}}</h2>
      <button
        type="button"
        class="opinion_search_closed"
        @click="toggleComment"
      >
      </button>
      <div class="scroll_box" ref="scrollBox" id="boardCmtScrollBox">
        <div ref="commentPanel">
          <div class="no-data" 
               v-if="commentList.length == 0" 
               v-html="$i18nUtil.trans('message.BoardComment.002','작성된 의견이 없습니다.블록별 의견 아이콘을 클릭하여 의견을 작성해 보세요.')">
          </div>
          <div class="progress" v-if="!state.ready">
            <ProgressCircle></ProgressCircle>
          </div>
          <div
            class="opinion_box"
            v-for="comment in commentList"
            :class="comment.deleteYn ? 'del' : ''"
            :key="'comment' + comment.commentId"
            :data-comment-id="comment.commentId"
            >
            <template v-if="!comment.deleteYn">
              <div class="name">
                <div class="droplayer relative">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        v-bind="attrs" 
                        v-on="on">
                        <b>{{ comment.regUserName }}</b>
                      </v-btn>
                    </template>
                    <div class="dropdown-list">
                      <UserTooltip :userId="comment.regUserId" />
                    </div>
                  </v-menu>
                </div>
                <span class="date">
                  {{ $moment(comment.regDate).format("YYYY.MM.DD HH:mm") }}
                </span>
              </div>
              <!--의견수정폼-->
              <div
                class="opinion-input_ty1 hidden"
                :ref="'commentEditBox' + comment.commentId"
              >
                <div
                  :class="'textarea emoUpdate' + comment.commentId"
                  :ref="'commentEditForm' + comment.commentId"
                  contenteditable
                  @keydown="commentKeyDown($event, comment.commentId)"
                  @keyup="commentKeyUp($event, comment.commentId)"
                  @keyup.delete="txtEmoticonModiDelYn($event,'addUpdate',comment.commentId)"
                  v-html="html(comment.comment)">
                </div>
                <!-- <div
                  class="textarea"
                  :ref="'commentEditForm' + comment.commentId"
                  contenteditable
                  @keydown="commentKeyDown($event, comment.commentId)"
                  @keyup="commentKeyUp($event, comment.commentId)"
                  @blur="commentBlur($event, 'update', comment.commentId)"
                  v-html="html(comment.comment)">
                </div> -->
                <div class="btn_box txtr hidden" :ref="'commentBtnBar' + comment.commentId">
                  <div class="message hidden" :ref="'warnMsg' + comment.commentId">
                    <span class="error">{{$i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                  </div>
                  <div class="message hidden" :ref="'warnMsg' + comment.commentId">
                    <span class="error">{{$i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                  </div>
                  <button
                    type="button"
                    class="btn-txt-primary"
                    @click="viewHidden('update', comment.commentId, true)">
                    {{$i18nUtil.trans("button.cancel","취소")}}
                  </button>
                  <button
                    type="button"
                    class="btn-txt-primary black"
                    @click="updateComment(comment)">
                    {{$i18nUtil.trans("button.modify","수정")}}
                  </button>
                  <button v-if="tenantId == '203'" type="button" :class="'btn-emoticon black txtEmoticonUpdate'+comment.commentId" @click="txtEmoticonUpdate(null, 'addUpdate',comment.commentId, $event)">
                  &nbsp;<span class="hide">이모티콘</span>
          </button>
                </div>
                <!-- <div class="btn_box txtr" :style="emoticonIconLoc()" v-show="emoticonIcon" :ref="'emoticonBtnR' + comment.commentId">
                  <button type="button" class="btn-emoticon" @click="toggleEmoticon(comment, 'modify', $event)"><span class="hide">이모티콘</span></button>
                </div> -->
              </div>
              <!--/의견수정폼-->
              <!--수정삭제버튼-->
              <div class="btn_box top" v-if="chkUser(comment)">
                <button
                  type="button"
                  class="btn-ico-del_ty1"
                  @click="deleteCommentModal(comment)">
                  {{$i18nUtil.trans("button.delete","삭제")}}
                </button>
                <button
                  v-if="comment.commentType != 'EMOTICON'"
                  type="button"
                  class="btn-ico-edit"
                  @click="viewHidden('update', comment.commentId)">
                  {{$i18nUtil.trans("button.modify","수정")}}
                </button>
              </div>
              <!--/수정삭제버튼-->
              <!--의견내용-->
              <div
                :ref="'commentEditBox' + comment.commentId"
                class="txt"
                :class="(comment.commentType === 'EMOTICON' ? 'reply-emoticon ' : '') +''+
                       (notiBoardCommentId == comment.commentId ? 'comment_highlight' :'')"
                v-html="comment.comment">
              </div>
              <!--/의견내용-->
            </template>
            <template v-else>
              <div class="txt">
                {{$i18nUtil.trans("message.ProjectComment.005","삭제된 의견입니다.")}}
              </div>
            </template>
            <dl class="reply_box" v-if="comment.commentCount > 0">
              <dt class="active"
                @click="viewHidden('write', comment.commentId)"
                v-if="comment.commentCount"
                v-html="$i18nUtil.trans('search.000.reply','총 {cnt} 건의 답변',{cnt:comment.commentCount})">
              </dt>
              <dd>
                <div
                  v-for="reply in commentMap[comment.commentId].replyList"
                  :key="'reply' + reply.commentId"
                  :data-comment-id="reply.commentId">
                  <div class="opinion_box"
                    :class="reply.deleteYn ? 'del' : ''">
                    <template v-if="!reply.deleteYn">
                      <div class="name">
                        <div class="droplayer relative">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn 
                                v-bind="attrs" 
                                v-on="on">
                                <b>{{ reply.regUserName }}</b>
                              </v-btn>
                            </template>
                            <div class="dropdown-list">
                              <UserTooltip :userId="reply.regUserId" />
                            </div>
                          </v-menu>
                        </div>
                        <span class="date">
                          {{ $moment(reply.regDate).format("YYYY.MM.DD HH:mm") }}
                        </span>
                        <div class="btn_box top" v-if="chkUser(reply)">
                          <button
                            type="button"
                            class="btn-ico-del_ty1"
                            @click="deleteCommentModal(reply)">
                            {{$i18nUtil.trans("button.delete","삭제")}}
                          </button>
                          <button
                            v-if="reply.commentType != 'EMOTICON'"
                            type="button"
                            class="btn-ico-edit"
                            @click="viewHidden('update', reply.commentId)">
                            {{$i18nUtil.trans("button.modify","수정")}}
                          </button>
                        </div>
                      </div>
                      <div
                        :ref="'commentEditBox' + reply.commentId"
                        class="txt"
                        :class="(comment.commentType === 'EMOTICON' ? 'reply-emoticon ' : '')+''+
                                (notiBoardCommentId == reply.commentId ? 'comment_highlight' :'')"
                        v-html="reply.comment"
                        >
                      </div>
                      <div
                        class="opinion-input_ty1 hidden"
                        :ref="'commentEditBox' + reply.commentId"
                      >
                        <div
                          :class="'textarea editor reply ediEmo'+reply.commentId"
                          :ref="'commentEditForm' + reply.commentId"
                          contenteditable
                          @keydown="commentKeyDown($event, reply.commentId)"
                          @keyup="commentKeyUp($event, reply.commentId)"
                          @keyup.delete="txtEmoticonModiDelYn($event,'replyUpdate',reply.commentId)"
                          style="display: block"
                          v-html="html(reply.comment)">
                        </div>

                        <div class="btn_box txtr hidden" :ref="'commentBtnBar' + reply.commentId">
                          <div class="message hidden" :ref="'warnMsg' + reply.commentId">
                            <span class="error">{{$i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                          </div>
                          <div class="message hidden" :ref="'warnMsg' + reply.commentId">
                            <span class="error">{{$i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                          </div>
                          <button
                            type="button"
                            class="btn-txt-primary"
                            @click="viewHidden('update', reply.commentId, true)">
                            {{$i18nUtil.trans("button.cancel","취소")}}
                          </button>
                          <button
                            type="button"
                            class="btn-txt-primary black"
                            @click="updateComment(reply)">
                            {{$i18nUtil.trans("button.modify","수정")}}
                          </button>
                          <button v-if="tenantId == '203'" type="button" :class="'btn-emoticon black replyEmoticonUpdate'+reply.commentId" @click="txtEmoticonUpdate(null, 'replyUpdate',reply.commentId, $event)">
                          &nbsp;<span class="hide">이모티콘</span>
                          </button>
                        </div>
                        <div class="btn_box txtr" :style="emoticonIconLoc()" v-show="emoticonIcon" :ref="'emoticonBtnR' + reply.commentId">
                          <button type="button" class="btn-emoticon" @click="toggleEmoticon(reply, 'modify', $event)"><span class="hide">이모티콘</span></button>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="del txt">
                        {{$i18nUtil.trans("message.ProjectComment.008","삭제된 답변입니다.")}}
                      </div>
                    </template>
                  </div>
                </div>
              </dd>
            </dl>
            <div 
              :ref="'commentWriteBox' + comment.commentId"
              class="opinion-input_ty1 emoticon hidden">
              <div
                :ref="'usageMsgR' + comment.commentId"
                class="block-usage textarea placeholder"
                @click="commentFocus($event, comment.commentId)"
              >
                {{ !emoticonIcon ? $i18nUtil.trans('message.placeholder.comment','의견을 입력하고 @사용자이름으로 대상자를 호출하세요.')
                            : $i18nUtil.trans('message.placeholder.cmt','이모티콘을 등록하거나 의견을 입력 후 @사용자이름으로 대상자를 호출해보세요.') }}
              </div>
              <!-- <div
                :ref="'usageMsgR' + comment.commentId"
                class="block-usage textarea placeholder"
                @mousemove="commentMouseMove($event, 'write', comment.commentId)"
                @mouseout="commentMouseMove($event, 'write', comment.commentId)"
                @click="commentFocus($event, comment.commentId)">
                {{$i18nUtil.trans("message.ProjectComment.009","답변을 입력하고 @사용자이름으로 대상자를 지정하세요")}}
              </div> -->
              <div
                :ref="'commentWriteForm' + comment.commentId"
                :class="'textarea editor'+ comment.commentId"
                @keydown="commentKeyDown($event, 'R' + comment.commentId)"
                @keyup="commentKeyUp($event, 'R' + comment.commentId)"
                @keyup.delete="txtEmoticonModiDelYn($event,'addReply',comment.commentId)"
                contenteditable>
              </div>
              <!-- <div
                :ref="'commentWriteForm' + comment.commentId"
                class="textarea editor"
                @keydown="commentKeyDown($event, 'R' + comment.commentId)"
                @keyup="commentKeyUp($event, 'R' + comment.commentId)"
                @blur="commentBlur($event, 'write', comment.commentId)"
                contenteditable>
              </div> -->
              <div class="hidden" :ref="'mentionSample' + comment.commentId">
                &nbsp;<span class="tag mention" :data-user-id="comment.regUserId" :data-user-name="comment.regUserName" :data-callEx-id="createFindKey()">@{{comment.regUserName}}</span>&nbsp;
              </div>
              <div class="btn_box txtr hidden" :ref="'commentBtnBarR' + comment.commentId">
                <div class="message hidden" :ref="'warnMsgR' + comment.commentId">
                  <span class="error">{{$i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                </div>
                <div class="message hidden" :ref="'warnMsgR' + comment.commentId">
                  <span class="error">{{$i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                </div>
                <button
                  type="button"
                  class="btn-txt-primary"
                  @click="viewHidden('write', comment.commentId, true)">
                  {{$i18nUtil.trans("button.cancel","취소")}}
                </button>
                <button
                  type="button"
                  class="btn-txt-primary black"
                  @click="writeComment(comment)">
                  {{$i18nUtil.trans("button.register","등록")}}
                </button>
                <button v-if="tenantId == '203'" type="button" :class="'btn-emoticon black txtReplyEmoticon'+comment.commentId" @click="txtEmoticonUpdate(null, 'addReply',comment.commentId, $event)">
                &nbsp;<span class="hide">이모티콘</span>
                </button>
              </div>
              <div class="btn_box txtr" :style="emoticonIconLoc()" v-show="emoticonIcon" :ref="'emoticonBtnR' + comment.commentId">
                <button type="button" class="btn-emoticon" @click="toggleEmoticon(comment, 'regist', $event)"><span class="hide">이모티콘</span></button>
              </div>
            </div>
            <button
              :ref="'commentWriteBox' + comment.commentId"
              type="button"
              class="btn-txt-underline reply"
              v-if="!comment.deleteYn"
              @click="viewHidden('write', comment.commentId)">
              {{$i18nUtil.trans("button.answer","답변하기")}}
            </button>
          </div>
          <!-- //opinion_box -->
        </div>
      </div>
      <!-- //scroll_box -->
      <div class="opinion-input_ty1 emoticon" v-for="inx in [1]" :key="inx">
        <div
          :ref="'usageMsgR'"
          class="block-usage textarea placeholder"
          @click="commentFocus($event, '')"
        >
          {{ !emoticonIcon ? $i18nUtil.trans('message.placeholder.comment','의견을 입력하고 @사용자이름으로 대상자를 호출하세요.')
                            : $i18nUtil.trans('message.placeholder.cmt','이모티콘을 등록하거나 의견을 입력 후 @사용자이름으로 대상자를 호출해보세요.') }}
        </div>
        
        <!-- <div
          :ref="'usageMsgR'"
          class="block-usage textarea placeholder"
          @mousemove="commentMouseMove($event, 'write', '')"
          @mouseout="commentMouseMove($event, 'write', '')"
          @click="commentFocus($event, '')">
          {{$i18nUtil.trans("message.placeholder.comment","의견을 입력하고 @사용자이름으로 대상자를 호출하세요.")}}
        </div> -->
        <div class="textarea txtEmoticonAdd"
          :ref="'commentWriteForm'"
          @keydown="commentKeyDown($event, 'R')"
          @keyup="commentKeyUp($event, 'R')"
          @keyup.delete="txtEmoticonDelYn"
          @blur="commentBlur($event, 'write', '')"
          contenteditable>
        </div>
        <div class="btn_box txtr hidden" ref="commentBtnBarR">
          <div class="message hidden" :ref="'warnMsgR'">
            <span class="error">{{$i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
          </div>
          <div class="message hidden" :ref="'warnMsgR'">
            <span class="error">{{$i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.")}}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
          </div>
          <button
            type="button"
            class="btn-txt-primary"
            @click="viewHidden('write', '', true)">
            {{$i18nUtil.trans("button.cancel","취소")}}
          </button>
          <button
            type="button"
            class="btn-txt-primary black"
            @click="writeComment('')">
            {{$i18nUtil.trans("button.register","등록")}}
          </button>
          <button v-if="tenantId == '203'" type="button" class="btn-emoticon black txtEmoticon" @click="toggleEmoticon(null, 'add', $event)">
          &nbsp;<span class="hide">이모티콘</span>
          </button>
        </div>
        <div class="btn_box txtr" :style="emoticonIconLoc()" v-show="emoticonIcon" ref="emoticonBtnR">
          <button type="button" class="btn-emoticon" @click="toggleEmoticon(null, 'regist', $event)"><span class="hide">이모티콘</span></button>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import ProgressCircle from "../extensions/ProgressCircle";
import SimpleModal from '../modal/SimpleModal.vue';

export default {
  components: {
    ProgressCircle,
    UserTooltip,
  },
  props: {
    boardUtil: Object,
    paperInfo: Object,
    blockInfo: Object,
    userInfo: Object,
    memberSelector: Object,
    boardMemberInfo: Object,
    emoticonSelector: Object,
    emoticonUse: Object,
    emoticonItem: String,
    allMemberId: String
  },

  data() {
    return {
      bdata: { },
      state: {
        ready: false,
        showCommentList: false,
        inputTarget: false,
        inputLength: 0,
        blurHandle: false,
        isIE: [ false ],
      },
      fileVer: null,
      // 화면에 뿌려질 데이터 (현재 화면의 데이터 리스트)
      commentMap: {},
      commentList: [],
      writeParam: {
        comment: "",
        paperId: "",
        paperBlockId: "",
        commentCount: 0,
        commentId: "",
        delDate: "",
        delUserId: null,
        deleteYn: 0,
        pageNo: 0,
        parentCommentId: "",
        regDate: "",
        regUserId: "",
        regUserName: "",
        versionSeq: "",
        targetUserId: [],
        targetUserName: [],
        callFindKeyMap : {},
        emoticonId: null,
        commentType: "TEXT",
        allMember: false
      },
      // 리스트에서 체크한 목록
      members: this.boardMemberInfo.userList,
      search: "",

      // 이모티콘
      tenantId: localStorage.getItem("tenantId"),
      emoticonIcon: false,
    };
  },
  created() {
    EventBus.$on("toggleComment", payload => {
      if (payload === true && this.state.showCommentList) {
        this.toggleComment();
      }
    });

    EventBus.$on("copaper.comment", param => {
      if (param.action != "count" && param.paperBlockId === this.bdata.paperBlockId) {
        this.getCommentList();
      }
    });

    EventBus.$on("brdCommentEmoticon", payload => {      
      let type = payload.comment ? payload.comment.commentType : null;
      let item = payload.item; // 등록할 이모티콘 정보

      let comment = payload.comment == null ? '' : payload.comment;
      let commentId = payload.comment == null ? '' : comment.commentId;
      let textbox = payload.type === 'regist' ? this.$refs["commentWriteForm" + commentId] ? this.$refs["commentWriteForm" + commentId][0] : ""
                  : this.$refs["commentEditForm" + commentId] ? this.$refs["commentEditForm" + commentId][0] : "";
     
      if (textbox) {
        // 2021-11-19 이모티콘 입력 시, 텍스트 초기화 기능 미사용으로 주석처리
        // let textarea = textbox.innerHTML;
        // textarea = textarea.replace(/^[  \t\r\n\0]+/gi, "");
        // textarea = textarea.replace(/[  \t\r\n\0]+$/gi, "");
        // textarea = textarea.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/g,"");  // 빈 값이어도 IE에서 <br> 들어가있어서 태그 삭제 정규식 추가
        // textarea = textarea.replace("&nbsp;", ""); // IE 답변 (멘션) 지운 후 이모티콘 입력 시, &nbsp; 있어 replace 추가
        // if(textarea !== "" && type !== "EMOTICON" && !confirm("이모티콘 등록 시, 작성된 의견은 삭제됩니다. 등록하시겠습니까?")) {
        //   this.initText();
        //   return false;
        // }
        
        this.writeParam.emoticonId = item.emoticonId;
        this.writeParam.commentType = "EMOTICON";
        payload.type == 'modify' ? this.updateComment(comment) : this.writeComment(comment);
      }
    });
  },
  mounted() {
    this.$refs.scrollBox.removeEventListener("scroll", this.scrollCommentList);
    this.$refs.scrollBox.addEventListener("scroll", this.scrollCommentList);
    this.CHECK_IE({res: this.state.isIE});
  },
  watch: {
    "blockInfo.commentSelectId": {
      handler() {
        this.commentList.splice(0, this.commentList.length);
        let paperBlockId = this.blockInfo.commentSelectId;
        if (paperBlockId) {
          if (!this.state.showCommentList) {
            this.state.showCommentList = true;
          }
          let bdata = this.blockInfo.paperBlockMap[paperBlockId].bdata;
          for (let k in bdata) {
            this.bdata[k] = bdata[k];
          }
          this.getCommentList({goto: 1}); 
        }
        else {
          this.state.showCommentList = false;
        }
        this.memberSelector.cancelMemberSelect(this.state.inputTarget);
        /* 블럭별 의견 토글 시, 신규 의견 작성영역 내용 초기화 */
        if(this.$refs.commentWriteForm[0] != null) {
          let list = this.$refs.commentWriteForm[0];
          if(list) {
            list.innerHTML = "";
            list.classList.toggle("hidden");
          }
        }
      }
    },
    "emoticonUse.brdCommentEmoticon": {
      handler() {
        this.emoticonIcon = this.emoticonUse[this.emoticonItem];
      }
    },
  },
  computed: {
    ...mapState("evdControl", ["KEYCODES", "EVENT_TYPES"]),
    ...mapState("noti", ["notiBoardBlockId","notiBoardCommentId"]),
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["CHECK_AND_LAUNCH", "CHECK_IE", "HW_KEYGEN"]),
    ...mapActions("evdControl", ["TRIGGER_EVENT", "CANCEL_EVENT"]),
    toggleComment() {
      /* 블럭별 의견 토글 시, 신규 의견 작성영역 내용 초기화 */
      if(this.$refs.commentWriteForm[0] != null) {
        let list = this.$refs.commentWriteForm[0];
        if(list) {
          list.innerHTML = "";
          list.classList.toggle("hidden");
        }
      }


      if (!this.state.showCommentList) {
        this.state.showCommentList = true;
      }
      else {
        this.state.showCommentList = false;
        this.blockInfo.commentSelectId = false;
        this.memberSelector.cancelMemberSelect(this.state.inputTarget);
      }

      // document.querySelector('.board-wrap-new').classList.toggle('active');
      // document.getElementById("paperAllComment").removeAttribute("style");
    },
    getCommentList(param) {
      let self = this;
      self.state.ready = false;

      self.CHECK_AND_LAUNCH({ check(ctx) {
        return !self.$el.classList.contains("active");
      }, launch(ctx) {
        /* 보드내 의견검색창 스크롤 상태를 따라간다. */
        let commentSearch = document.getElementById("paperAllComment");
        if (commentSearch.classList.contains("top")) {
          self.$el.classList.add("top");
        }
        else {
          self.$el.classList.remove("top");
        }
      } });

      let request = {
        url: "/api/copaper/opinion/commentList",
        method: "post",
        params: {
          paperId: self.bdata.paperId,
          paperBlockId: self.bdata.paperBlockId
        }
      };
      self.COWORK_REST_SIMPLE_ACTION(request).then(resp => {
        if (!resp) { return; }
        if (resp.errorCode) { console.log('/commentList errorCode', resp.errorCode); }
        let result = resp.result;
        self.commentProcess(result, param);
      });
    },
    commentProcess(resultParam, param) {
      let result = resultParam;
      if(this.$i18nUtil.getLanguage() === 'ko') {

      }else{
        result.forEach(rl => {
          rl.regUserName = rl.regUserNameEn != null ? rl.regUserNameEn : rl.regUserName;
        })
      }

      let self = this;
      let commentList = self.commentList;
      let commentMap = self.commentMap;
      commentList.splice(0, self.commentList.length);
      for (let k in commentMap) { delete commentMap[k]; }
      let fnGetMap = ((commentId, comment) => {
        if (!commentMap[commentId]) {
          commentMap[commentId] = { comment, replyList: [] };
        }
        else if (!comment) {
          comment = commentMap[commentId].comment;
        }
        if (comment) {
          comment.commentCount = commentMap[commentId].replyList.length;
        }
        return commentMap[commentId];
      });
      let count = 0;
      let traceComment = [result[0], result[0]];
      if (!result[0]) {
        traceComment = [{ }, { }];
      }
      for (let inx = 0; inx < result.length; inx++) {
        let comment = result[inx];

        /* 이모티콘 img 태그 추가 */
        if(comment.commentType === "EMOTICON") {
          comment.comment = self.$emoticonFn.getEmoticonImg(self.tenantId, comment.emoticonId);
        }
          
        if(comment.emoticonId != null || comment.emoticonId != ''){
          comment.comment = comment.comment.replace('/mneo/OKRCOWORK_FRONTEND_NATIVE','');
        }

        if (!comment.deleteYn) {
          count++;
          if (comment.regDate > traceComment[0].regDate) {
            traceComment[0] = comment;
          }
        }
        if (!comment.parentCommentId) {
          commentList.push(comment);
          fnGetMap(comment.commentId).comment = comment;
          if (comment.regDate > traceComment[1].regDate) {
            traceComment[1] = comment;
          }
        }
        else {
          let parent = fnGetMap(comment.parentCommentId);
          parent.replyList.push(comment);
          if (parent.comment) {
            parent.comment.commentCount = parent.replyList.length;
          }
          fnGetMap(comment.commentId).comment = comment;
        }
      }
      self.blockInfo.commentCounts[self.bdata.paperBlockId] = count;
      EventBus.$emit("copaper.comment", {
        action: "count",
        paperBlockId: self.bdata.paperBlockId,
        count: count,
      });
      self.state.ready = true;

      /* 최초 진입시 가장최근 의견으로 이동 (최하단 으로 스크롤) */
      if(self.notiBoardCommentId != null){
        self.gotoComment(self.notiBoardCommentId);
      }else{
        if (param) {
          if (param.goto === 0) {
            /* 답변포함 최근의견 */
            self.gotoComment(traceComment[0].commentId);
          }
          else if (param.goto === 1) {
            /* 답변제외 최근의견 */
            self.gotoComment(traceComment[1].commentId);
          }
          else {
            /* 직접접근 */
            self.gotoComment(param.goto);
          }
        }
      }
    },
    gotoComment(commentId) {
      let self = this;
      self.CHECK_AND_LAUNCH({ check(ctx) {
        let panelHeight = self.$refs.commentPanel ? self.$refs.commentPanel.offsetHeight : 0;
        let scrollBoxHeight = self.$refs.scrollBox ? self.$refs.scrollBox.offsetHeight : 0;
        if (!ctx.panelHeight || ctx.panelHeight != panelHeight) {
          ctx.panelHeight = panelHeight;
          ctx.scrollBoxHeight = scrollBoxHeight;
          return false;
        }
        return true;
      }, launch(ctx) {
        let scrollTop = 0;
        let diffTop = 50;
        if (commentId) {
          let list = self.$el.querySelectorAll("[data-comment-id]");
          for (let item of list) {
            if (item.getAttribute("data-comment-id") === commentId) {
              if (self.commentMap[commentId].comment.parentCommentId) {
                scrollTop = item.offsetTop + 
                  item.parentNode.parentNode.parentNode.offsetTop - diffTop - 5;
              }
              else {
                scrollTop = item.offsetTop - diffTop;
              }
              self.$refs.scrollBox.scrollTop = scrollTop;
              // console.log("SCROLL:", scrollTop, self.commentMap[commentId], item);
            }
          }
        }
        else {
          scrollTop = ctx.panelHeight - ctx.scrollBoxHeight + diffTop;
          if (scrollTop < 0) { scrollTop = 0; }
          self.$refs.scrollBox.scrollTop = scrollTop;
          // console.log("SCROLL:", scrollTop);
        }
      }, interval: 200 });
    },
    deleteCommentModal(param) {
      let self = this;
      let msg = self.$i18nUtil.trans("AB005"); // 의견을 삭제하시겠습니까?
      self.confirmModal(msg, (modal) => {
        modal.close();
        let request = {
          url: "/api/copaper/opinion/deleteComment",
          method: "post",
          params: param,
        };
        self.COWORK_REST_SIMPLE_ACTION(request).then(response => {
          if (response.errorCode) {
            console.log('/deleteComment errorCode', response.errorCode);
          }
          msg = self.$i18nUtil.trans("TB092"); // 의견이 삭제되었습니다
          param.deleteYn = 1;
          self.toast(msg);
          // EventBus.$emit(name, { action: "delete", paperBlockId: self.bdata.paperBlockId });
          self.commentList = response.result;
          self.viewHidden("update", param.commentId, true);
          self.getCommentList();
        });
      }, [{}, {text:self.$i18nUtil.trans("button.delete","삭제")}]);
    },
    html(html) {
      let regex = /[<][/]span[>][ \0\r\n]*$/;
      if (regex.exec(html.toLowerCase())) {
        // 멘션태그와 붙는것을 방지.
        html = html + "\&nbsp;";
      }
      return html;
    },
    confirmModal (msg, callback, labels) {
      if (!labels) { labels = [{},{}]; }
      for (let inx in [0, 1]) {
        labels[inx] = labels[inx] || {};
      }
      const modalInfo = {
        obj: this.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ 
          { label: labels[0].text || this.$i18nUtil.trans("button.cancel","취소"), class: labels[0].cls || "btn_ty2", click(modal) { modal.close(); }},
          { label: labels[1].text || this.$i18nUtil.trans("button.confirm","확인"), class: labels[1].cls || "btn_ty1", click: callback },
        ]
      };
      this.showModal(modalInfo);
    },
    alertModal(msg) {
      const modalInfo = {
        obj: this.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ { label: this.$i18nUtil.trans("button.confirm","확인"), class: "btn_ty1", click(modal) { modal.close(); }} ]
      };
      this.showModal(modalInfo);
    },
    toast(toastMsg) {
      let toastInfo = {
        obj: this.$toasted,
        message: toastMsg,
        options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
      };
      this.showToast(toastInfo);
    },
    writeComment(param) {
      let self = this;
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      if (!param) { param = { commentId: "" }; }
      let form = self.writeParam;
      let userIdList = [];
      let userNameList = [];
      let callFindKeyMap ={};
      let element = self.$refs["commentWriteForm" + param.commentId][0];
      let validate = false;
  
      if (form.commentType == "TEXT") {
        // let element = self.$refs["commentWriteForm" + param.commentId][0];

        // 의견 등록시 개인식별번호 체크.
        let pinCheckHTML = this.pinBlockCheck(element.innerHTML);
        element.innerHTML = pinCheckHTML; 

        let innerText = element.innerText;
        innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
        innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
        if (!innerText) {
          let msg = self.$i18nUtil.trans("AB014");
          self.alertModal(msg);
          return;
        }

        if (self.validateComment(element.innerText, "R" + param.commentId)) {
          // let form = self.writeParam;
          for (let k in param) { 
            if (k !== 'commentType' && k !== 'emoticonId') form[k] = param[k];
          }
          // form.paperId = self.bdata.paperId;
          // form.paperBlockId = self.bdata.paperBlockId;
          form.comment = element.innerHTML;

          // let userIdList = [];
          // let userNameList = [];
          for (let inx = 0, list = element.querySelectorAll("[data-user-id]");
            inx < list.length; inx++) {
            let userId = list[inx].getAttribute("data-user-id");
            if (userId === self.allMemberId) form.allMember = true;
            userIdList.push(userId);
            // userIdList.push(list[inx].getAttribute("data-user-id"));
            userNameList.push(list[inx].getAttribute("data-user-name"));
            callFindKeyMap[list[inx].getAttribute("data-user-id")] = list[inx].getAttribute("data-callEx-id")
          }
          // form.targetUserId = userIdList;
          // form.targetUserName = userNameList;
          validate = true;
        }
      }else if (form.commentType == "EMOTICON") {
        form.comment = "";
        form.emoticonId = self.writeParam.emoticonId;
        form.commentId = param ? param.commentId : "";
        validate = true;
      }

      form.paperId = self.bdata.paperId;
      form.paperBlockId = self.bdata.paperBlockId;
      form.targetUserId = userIdList;
      form.targetUserName = userNameList;
      form.callFindKeyMap = callFindKeyMap;
      if(validate) {
        let url = "/api/copaper/opinion/commentWrite";
        self.$axios.post(url, form).then(response => {
          self.commentProcess(response.data.result, { goto: 0 });
          element.innerHTML = "";
          self.initText();
          self.viewHidden("write", param.commentId, true);
          self.writeParam.allMember = false;
          EventBus.$emit("copaper.comment", { action: "write", paperBlockId: self.bdata.paperBlockId });
        });
      }
      if(document.querySelector(".txtEmoticon > .hide") != null){
        document.querySelector(".txtEmoticon").classList.remove('hide')
      }
    },
    viewHidden(type, commentId, ignoreConfirm = false) {
      //onsole.log("답변하기 : " + type);
      // 댓글 수정 텍스트+이모티콘 
      if(this.tenantId == '203'){
        if(type=='update'){
          if(document.querySelector(".emoUpdate"+commentId + " .txtAddEmoticon") != null) {
            document.querySelector(".txtEmoticonUpdate" + commentId).classList.add('hide')
          }
          // 답변하기 수정 텍스트+이모티콘
          if(document.querySelector(".textarea.editor.reply.ediEmo"+commentId + " .txtAddEmoticon") != null) {
            document.querySelector(".replyEmoticonUpdate" + commentId).classList.add('hide')
          }
        }else{
          // 답변하기
          if(document.querySelector(".textarea.editor"+commentId + " .txtAddEmoticon") == null) {
            if(document.querySelector(".txtReplyEmoticon" + commentId) != null){
              document.querySelector(".txtReplyEmoticon" + commentId).classList.remove('hide')
            }
          }
        }
      }


      let self = this;
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      if (type == "write") {
        let list = self.$refs["commentWriteBox" + commentId];
        let fnToggle = ((delYn) => {
          if (list) {
            list.forEach(el => { el.classList.toggle("hidden"); });
          }
          self.initText();
          self.$refs["commentWriteForm" + commentId][0].innerHTML = "";
          self.$refs["warnMsgR" + commentId].forEach(el => { el.classList.add("hidden"); });
          self.$refs["usageMsgR" + commentId][0].classList.remove("hidden");
          self.$refs["commentBtnBarR" + commentId][0].classList.add("hidden");

          // 이모티콘 아이콘 hidden true/false
          let icon = self.$refs["emoticonBtnR" + commentId];
          for(let i=0; i<icon.length; i++) {
            if(icon[i].children.length > 0 && icon[i].children[0].classList.contains('btn-emoticon')) {
              icon[i].children[0].classList.remove('hidden');
            }
          }
          
        });
        if ((!list || !list[0].classList.contains("hidden")) && !ignoreConfirm) {
          let msg = self.$i18nUtil.trans("AB004"); // 의견을 삭제하시겠습니까?
          self.confirmModal(msg, (modal) => {
            modal.close();
            fnToggle(false);
          }, [{}, {text:self.$i18nUtil.trans("button.delete","삭제")}]);
        }
        else {
          fnToggle(true);
        }
      }
      else if (type == "update") {
        let list = self.$refs["commentEditBox" + commentId];
        list.forEach(el => { 
          let nodeList = el.childNodes;
          el.classList.toggle("hidden");
          if (self.commentMap[commentId].comment.commentType == "EMOTICON") {
            for (let i=0; i<nodeList.length; i++) {
              let child = nodeList[i];
              if (child.classList && child.classList.contains('textarea')) {
                child.removeAttribute('contenteditable');
              }
            }
          }else if (self.commentMap[commentId].comment.commentType == "TEXT") {
            for (let i=0; i<nodeList.length; i++) {
              let child = nodeList[i];
              if (child.classList && child.classList.contains('textarea')) {
                if(!child.getAttribute('contenteditable')) {
                  child.setAttribute('contenteditable', true);
                }
              }
            }
            self.$refs["emoticonBtnR" + commentId][0].classList.add("hidden");
          }
        });
        if (list[0].classList.contains("hidden")) {
          self.$refs["commentEditForm" + commentId][0].innerHTML = self.commentMap[commentId].comment.comment;
          self.$refs["warnMsg" + commentId].forEach(el => { el.classList.add("hidden"); });
          self.$refs["commentBtnBar" + commentId][0].classList.add("hidden");
        }
      }
      if (!self.memberSelector.$el.classList.contains("hidden")) {
        self.memberSelector.cancelMemberSelect(self.state.inputTarget);
      }
    },
    updateComment(param) {
      if (this.state.blurHandle) { clearTimeout(this.state.blurHandle); }
      this.state.blurHandle = "BUTTONCLICK";
      let element = this.$refs["commentEditForm" + param.commentId][0];

      let form = this.writeParam;
      let userIdList = [];
      let userNameList = [];
      let callFindKeyMap = {};
      let validate = false;

      if (form.commentType == "TEXT") {
        // 의견 등록시 개인식별번호 체크.
        let pinCheckHTML = this.pinBlockCheck(element.innerHTML);
        element.innerHTML = pinCheckHTML; 

        let innerText = element.innerText;
        innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
        innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
        if (!innerText) {
          let msg = this.$i18nUtil.trans("AB014");
          this.alertModal(msg);
          return;
        }
        if (this.validateComment(element.innerText, param.commentId)) {
          for (let k in param) { 
            if (k !== 'commentType' && k !== 'emoticonId') form[k] = param[k]; 
          }
          form.comment = element.innerHTML;

          for (let inx = 0, list = element.querySelectorAll("[data-user-id]");
            inx < list.length; inx++) {
            let userId = list[inx].getAttribute("data-user-id");
            if (userId === this.allMemberId) form.allMember = true;
            userIdList.push(userId);
            // userIdList.push(list[inx].getAttribute("data-user-id"));
            userNameList.push(list[inx].getAttribute("data-user-name"));
            callFindKeyMap[list[inx].getAttribute("data-user-id")] = list[inx].getAttribute("data-callEx-id")
          }

          validate = true;
        }
      }else if (form.commentType == "EMOTICON") {
        form.comment = "";
        form.commentId = param.commentId;
        form.regUserId = param.regUserId;
        validate = true;
      }
      
      form.paperId = this.bdata.paperId;
      form.paperBlockId = this.bdata.paperBlockId;
      form.targetUserId = userIdList;
      form.targetUserName = userNameList;
      form.callFindKeyMap = callFindKeyMap;

      if (validate) {
        let url = "/api/copaper/opinion/updateComment";
        this.$axios.post(url, form).then(response => {
          this.commentList = response.data.result;
          this.initText();
          this.viewHidden("update", param.commentId, true);
          this.writeParam.allMember = false;
          this.getCommentList({ goto: param.commentId });
        });
      }
      
    },
    commentFocus(e, commentId) {
      if (this.state.blurHandle) {
        clearTimeout(this.state.blurHandle);
        this.state.blurHandle = null;
      }
      let editor = this.$refs["commentWriteForm" + commentId][0];
      let sample = this.$refs["mentionSample" + commentId];
      let btnBar = this.$refs["commentBtnBarR" + commentId];
      let innerText = editor.innerText;
      innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
      innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
      if (e.target) {
        e.target.classList.add("hidden");

        if(e.target.parentElement.children) {
          // 이모티콘 아이콘 hidden true/false
          let el = e.target.parentElement.children;
          for(let i=0; i<el.length; i++) {
            if(el[i].children.length > 0 && el[i].children[0].classList.contains('btn-emoticon')) {
              el[i].children[0].classList.add('hidden');
            }
          }
        }
        
        if (sample && sample[0] && !innerText) {
          editor.innerHTML = sample[0].innerHTML;
          btnBar[0].classList.remove("hidden");
        }
        editor.focus();
        if (editor.innerHTML && editor.childElementCount > 0) {
          setTimeout(() => {
            document.getSelection().collapse(editor.lastChild, 1);
          }, 100);
        }
      }
    },
    validateComment(text, commentId) {
      this.state.inputLength = text.length;
      let warnMsg = this.$refs["warnMsg" + commentId];
      warnMsg.forEach(el => { el.classList.add("hidden"); });
      if (text.length > 500) {
        warnMsg[0].classList.remove("hidden");
        // console.log("의견은 500글자 이상 작성하실수 없습니다.", el);
        return false;
      }
      if (text.length < 1) {
        warnMsg[1].classList.remove("hidden");
        // console.log("의견은 1글자 이상 작성해 주세요", el);
        return false;
      }
      return true;
    },
    commentKeyUp(e, commentId) {
      this.processKey(e, commentId, () => { this.memberSelector.editorKeyUp(e); });
    },
    commentKeyDown(e, commentId) {
      let self = this;
      let target = e.target;
      target.$evt = e;
      /* IE관련 키이벤트를 받기 위한편법, MutationObserver를사용한다.*/
      if (!target.$inputObserver) {
        if (target.$inputObserver) { target.$inputObserver.disconnect(); }
        let observer = new MutationObserver((mutationsList, observer) => {
          self.processKey(target.$evt, commentId, () => { self.memberSelector.editorKeyInput(target.$evt); });
        });
        observer.observe(target, { attributes: true, subtree: true, childList: false, characterData: true });
        target.$inputObserver = observer;
      }
      self.processKey(e, commentId, () => {
        self.memberSelector.editorKeyDown(e, {
          positionAdjust: self.memberSelectorPosition, 
          closeCallback: self.memberSelectorCallback,
          inviteCallback(success, userId, companyId, memberList, blockedList) {
            if (self.state.callMemberProcess) {
              if (blockedList != null && blockedList.length > 0) {
                success = false;
                console.log("BLOCKED:", blockedList);
              }
              self.state.callMemberProcess(success);
              delete self.state.callMemberProcess;
            }
            self.$emit("initPaperUserList");
          },
          contentEditable: true, autoInvite: 1
        });
      });
    },
    commentMouseMove(e, type, commentId) {
      let self = this;
      let etype = e.type;
      self.CANCEL_EVENT({event: e});
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      // console.log("ETYPE:", etype, e.target.classList);
      if (etype === "mouseout") {
        if (!e.target.classList.contains("hidden")) {
          self.state.blurHandle = setTimeout(() => {
            self.viewHidden(type, commentId, true);
          }, 100);
        }
      }
    },
    commentBlur(e, type, commentId) {
      let self = this;
      self.CANCEL_EVENT({event: e});
      if (self.state.blurHandle) {
        /* 등록 버튼을 먼저 누르고 온 경우 */
        if (self.state.blurHandle == "BUTTONCLICK") {
          self.state.blurHandle = null;
          return;
        }
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      self.state.blurHandle = setTimeout(() => {
        let input = null;
        if (type == "write") {
          input = self.$refs["commentWriteForm" + commentId][0];
          let innerText = input.innerText;
          innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
          innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
          // if (innerText.length > 0) {
          //   self.viewHidden(type, commentId);
          // }
          // else {
          //   self.$refs["commentWriteForm" + commentId][0].innerText = "";
          //   self.$refs["usageMsgR" + commentId][0].classList.remove("hidden");
          // }
          if (innerText.length < 1) {
            self.$refs["commentWriteForm" + commentId][0].innerText = "";
            self.$refs["usageMsgR" + commentId][0].classList.remove("hidden");
            self.$refs["commentBtnBarR" + commentId][0].classList.add("hidden");
            
            if (e.target.parentElement.children) {
              // 이모티콘 아이콘 hidden true/false
              let el = e.target.parentElement.children;
              for(let i=0; i<el.length; i++) {
                if(el[i].children.length > 0 && el[i].children[0].classList.contains('btn-emoticon')) {
                  el[i].children[0].classList.remove('hidden');
                }
              }
            }

          }else {

          }
        }
        else if (type == "update") {
          input = self.$refs["commentEditForm" + commentId][0];
        }
        self.memberSelector.cancelMemberSelect(input);
      }, 500);
    },
    processKey(e, commentId, callback) {
      let KEYCODES = this.KEYCODES;
      if (e.target) {
        this.state.inputTarget = e.target;
        if (callback) {
          callback();
        }
        let keyCode = e.keyCode;
        /* 멤버 호출 태그는 편집할수 없도록 */
        if (e.type == this.EVENT_TYPES.KEYDOWN) {
          setTimeout(() => {
            let selection = document.getSelection();
            if (selection.rangeCount == 0) { return; }
            let range = selection.getRangeAt(0);
            let current = range.startContainer;
            let tmpNode1 = current.parentNode;
            let tmpNode2 = current.nextSibling;
            let tmpNode3 = current.previousSibling;
            // console.log("OFFSET:" + keyCode + " / " + range.startOffset + " / " + current.length + " / " + 
            // current + " / " +
            // (tmpNode1 ? tmpNode1.nodeName : "#") + " / " + 
            // (tmpNode2 ? tmpNode2.nodeName : "#") + " / " + 
            // (tmpNode3 ? tmpNode3.nodeName : "#"));

            if (tmpNode1 && tmpNode1.nodeName == "SPAN" &&
              tmpNode1.classList.contains("mention") &&
              tmpNode1.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.BS) {
                if (tmpNode1.innerText.length <= tmpNode1.getAttribute("data-user-name").length) {
                  tmpNode1.parentNode.removeChild(tmpNode1);
                }
              }
              else if (keyCode == KEYCODES.DEL) {
                tmpNode2 = tmpNode1.nextSibling;
                if (tmpNode1.innerText.length <= tmpNode1.getAttribute("data-user-name").length) {
                  tmpNode1.parentNode.removeChild(tmpNode1);
                }
                if (tmpNode2 && tmpNode2.nodeName == "SPAN" && 
                  tmpNode2.classList.contains("mention") &&
                  tmpNode2.getAttribute("data-user-id") &&
                  tmpNode2.innerText.length <= tmpNode2.getAttribute("data-user-name").length) {
                  tmpNode2.parentNode.removeChild(tmpNode2);
                }
              }
              else if (keyCode == KEYCODES.LEFT) {
                if (range.endOffset < current.length) {
                  document.getSelection().collapse(tmpNode1, 0);
                }
              }
              else if (keyCode == KEYCODES.RIGHT) {
                if (range.startOffset > 0) {
                  document.getSelection().collapse(tmpNode1, 1);
                }
              }
              else if (keyCode == KEYCODES.ENTER) {
                if (!this.state.isIE[0]) {
                  let parentNode = tmpNode1.parentNode.parentNode;
                  if (parentNode.lastChild.previousSibling.nodeName == "SPAN") {
                    parentNode.removeChild(parentNode.lastChild.previousSibling);
                  }
                  tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                }
                else {
                  let parentNode = tmpNode1.parentNode.previousSibling;
                  if (parentNode.lastChild.nodeName == "SPAN") {
                    parentNode.removeChild(parentNode.lastChild);
                  }
                  tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                }
                return;
              }
              else {
                let nextNode = document.createTextNode(" ");
                tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                if (tmpNode1.nextSibling) {
                  tmpNode1.parentNode.insertBefore(nextNode, tmpNode1.nextSibling);
                } else {
                  tmpNode1.parentNode.appendChild(nextNode);
                }
                document.getSelection().collapse(nextNode, 1);
              }
            }
            else if (tmpNode2 && tmpNode2.nodeName == "SPAN" &&
              tmpNode2.classList.contains("mention") &&
              tmpNode2.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.DEL) {
                if (tmpNode2.innerText.length <= tmpNode2.getAttribute("data-user-name").length) {
                  tmpNode2.parentNode.removeChild(tmpNode2);
                }
              }
            }
            /* IE 예외사항. 호출태그 직후 백스페이스시 텍스트가 멘션태그에 병합되는 현상 방지  */
            else if (this.state.isIE[0] &&
              tmpNode1 && tmpNode1.nodeName == "P" &&
              !tmpNode2 && tmpNode3 && tmpNode3.nodeName == "#text" &&
              current.nodeName == "SPAN" &&
              current.classList.contains("mention") &&
              current.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.BS) {
                let innerText = current.innerText;
                let userName = current.getAttribute("data-user-name");
                let nextNode = document.createTextNode(innerText.substring(
                  userName.length + 1));
                current.innerHTML = "@" + userName;
                current.parentNode.appendChild(nextNode);
                current.parentNode.appendChild(document.createTextNode(" "));
              }
            }
          }, 1);
        }

        let usageMsg = this.$refs["usageMsg" + commentId];
        let btnBar = this.$refs["commentBtnBar" + commentId];
        let emoticonBtnR = this.$refs[commentId === 'R' ? "emoticonBtnR" : "emoticonBtn"+commentId];

        let innerText = e.target.innerText;
        innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
        innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
        if (!innerText) {
          if (usageMsg) {
            usageMsg[0].classList.remove("hidden");
          }
          if (btnBar) {
            // btnBar[0].classList.add("hidden");
            btnBar.length > 0 ? btnBar[0].classList.add("hidden") : btnBar.classList.add("hidden");
          }
          // if(emoticonBtnR) {
          //   // 의견 수정 시, 이모티콘 버튼 노출
          //   emoticonBtnR.length > 0 ? emoticonBtnR[0].classList.remove('hidden') : emoticonBtnR.classList.remove('hidden');
          // }
          // if(keyCode == KEYCODES.BS || keyCode == KEYCODES.DEL) {
          if(keyCode == KEYCODES.DEL) {
            /* 
              일자 : 2021.09.14.
              의견 작성 영역
                1. keyCode 가 BS 나 DEL 이면서 내용이 하나도 없을 경우, ie/chrome 
                  강제로 focusOut 을 시켜 모두 커서를 없애기 위해 강제 blur 발생 시킴
            */
            this.$refs.commentWriteForm[0].blur();
          }
        }
        else {
          if (usageMsg) {
            usageMsg[0].classList.add("hidden");
          }
          if (btnBar) {
            // btnBar[0].classList.remove("hidden");
            btnBar.length > 0 ? btnBar[0].classList.remove("hidden") : btnBar.classList.remove("hidden");
          }
          this.validateComment(e.target.innerText, commentId);
        }
        if (emoticonBtnR) {
          let el = emoticonBtnR.length > 0 ? emoticonBtnR[0].children : emoticonBtnR.children;
          if(innerText.length < 1 && this.emoticonIcon) {
            // 의견 텍스트 박스에 입력된 길이 === 0일 때, 의견 아이콘 show 설정
            for(let i=0; i<el.length; i++) {
              if(el[i].classList.contains('btn-emoticon')) {
                el[i].classList.remove('hidden');
              }
            }
          }else {
            // 의견 텍스트 박스에 입력된 길이 > 0 일 때, 의견 아이콘 hide 설정
            for(let i=0; i<el.length; i++) {
              if(el[i].classList.contains('btn-emoticon')) {
                el[i].classList.add('hidden');
              }
            }
          }
        }
      }
    },
    chkUser(param) {
      return param.regUserId == this.userInfo.userId;
    },
    memberSelectorPosition(pos, caret) {
      let el = this.$el;
      let top = el.offsetTop;
      let left = el.offsetLeft;
      let width = el.offsetWidth;
      let box = caret.parentNode;
      let boxTop = 0;
      let boxLeft = 0;
      let wscrollTop = window.scrollY || window.pageYOffset;
      let escrollTop = this.$refs.scrollBox.scrollTop;
      for (; box && !box.getAttribute("contenteditable"); box = box.parentNode ) { }
      if (!box) { return; }
      if (box === this.$refs.commentWriteForm[0]) {
        box = box.parentNode;
        boxTop = box.offsetTop;
        pos.top = top + boxTop + wscrollTop - 5;
      }
      else if (box.classList.contains("reply")) {
        box = box.parentNode;
          boxTop += box.offsetTop;
        box = box.parentNode;
          boxTop += box.offsetTop;
        for (let inx = 0; inx < 4; inx++, box = box.parentNode) { }
          boxTop += box.offsetTop;
        pos.top = top + boxTop + wscrollTop - escrollTop + 1;
      }
      else {
        box = box.parentNode;
        boxTop = box.offsetTop;
        box = box.parentNode;
        boxTop+= box.offsetTop;
        pos.top = top + boxTop + wscrollTop - escrollTop;
      }
      // console.log("HEIGHT:", this.memberSelector.$el.firstChild);
      // console.log("TOP:", pos.top, this.$refs.scrollBox.offsetTop);
      if (top + boxTop + caret.offsetTop - 470 < 0) {
        pos.reverse = true;
      }
      pos.left = left - width + 25;
      pos.left -= caret.offsetLeft - 10;
    },
    memberSelectorCallback(isCancel, item, caretElement) {
      let self = this;
      /**
       * 멤버 호출시 chinesewall 에 대한 방안
       * 1. 최초 보드(혹은 ) 멤버 목록 적재시 차단여부 불러옴
       * 2. 호출 프로세스를 람다콜백으로 선언
       * 3. 멤버에 있고, 차단대상이 아니면 바로 프로세스 실행
       * 4. 멤버에 없다면 람다콜백을 state 에 등록
       * 5. 초대 프로세스 실행하여 성공하면 state 에 등록된 람다콜백 실행
       */
      if (!isCancel && item) {
        let userId = item.getAttribute("data-user-id");
        let userName = item.getAttribute("data-user-name");
        if (userId && userName) {
          let removeTag = () => {
            console.log("REMOVE-TAG");
            let element = caretElement.element;
            let parent = element.parentNode;
            parent.removeChild(element);
            let range = document.getSelection().getRangeAt(0);
            element = range.startContainer.previousSibling;
            document.getSelection().collapse(element, 0);
            self.toast(self.$i18nUtil.trans("message.ProjectComment.001","사용자를 초대할수 없습니다."));
          };
          self.state.callMemberProcess = (success) => {
            console.log("CALL-USER:", userName, success);
            if (!success) { setTimeout(removeTag, 100); }
          };
          for (let member of self.members) {
            if (member.userId == userId) {
              self.state.callMemberProcess(true);
              delete self.state.callMemberProcess;
              break;
            }
          }
        }
      }
    },
    scrollCommentList(e) {
      this.memberSelector.cancelMemberSelect(this.state.inputTarget);
    },
    toggleEmoticon(comment, type, event) {
      /* 이모티콘 아이콘 활성화 */
      event.target.className === 'btn-emoticon' ? event.target.classList.add('active') : '';
      this.emoticonSelector.toggleEmoticonSelect(type, this.emoticonItem, comment, event);
    },
    txtEmoticonUpdate(comment, type,commentId, event) {
      /* 텍스트 > 이모티콘 수정 아이콘 활성화 */
      event.target.className === 'btn-emoticon' ? event.target.classList.add('active') : '';
      this.emoticonSelector.toggleEmoticonSelectUpdate(type, this.emoticonItem, comment,commentId, event);
    },
    initText() {
      // write type: default인 텍스트로 변경
      this.writeParam.emoticonId = null;
      this.writeParam.commentType = "TEXT";
    },
    emoticonIconLoc() {
      return 'position: relative; z-index: 10;';
    },
    pinBlockCheck(innerHTML){
      let retrunHtml = innerHTML;
      if(localStorage.getItem("pinBlockYn") == "true"){
        // 호출등 태그안에 있는 id 값들이 검색이되기 때문에 태그 제거후 검색
        let tempHtml  = innerHTML.replace(/^\0|&([^;])*;|\n/gi, " "); 
        let tempHtml1 = tempHtml.replace(/^[  \t\r\n\0]+/gi, "");
        let tempHtml2 = tempHtml1.replace(/[  \t\r\n\0]+$/gi, "");
        let tempHtml3 = tempHtml2.replace(/<(\/)?([a-zA-Z1-9]*)(\s[a-zA-Z1-9-]*=[^>]*)?(\s)*(\/)?>/g,"");
        
        let match = null;
        //주민등록번호 (20년 10월 신규 출생자 패턴)
        let regex1 = /((20((1[02])(0[1-9]|[12][0-9]|3[01])|(11)(0[1-9]|[12][0-9]|3[0])))|((2[1-9]|3[0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})/g;
        //주민등록번호 (기존 주민등록번호 변경 신청자)
        let regex2 =/(((\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))(-?| )([12]\d{6}))|((((20)((0[13578])(0[1-9]|[12][0-9]|3[01])|(0[469])(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9])))|(([01][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))))(-?| )([34]\d{6})))/g;
        // 외국인등록번호
        let regex3 =/(((2[1-9]|[3-9][0-9])((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([5-6]\d{6}))|(\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[469]|11)(0[1-9]|[12][0-9]|3[0])|(02)(0[1-9]|[12][0-9]))(-?| )([7-8]\d{6})))/g;
        // 전자여권번호
        let regex4 =/(\b)[Mm]\d{8}((?=\D)|$|\b)/g;
        // 신운전면허번호
        let regex5 =/((1[1-9]|2[0-6])-\d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2}-\d{6}-\d{2}|(1[1-9]|2[0-6]) \d{2} \d{6} \d{2})((?=[^a-zA-Z0-9`~!@#$%^&*()-=_+|\\])|$)/g;
        
        let result1 = regex1.exec(tempHtml3); 
        if (result1 != null) {
          match = result1;
          retrunHtml = retrunHtml.replace(match[0],"");
        }
        let result2 = regex2.exec(tempHtml3); 
        if(result2 != null){
          match = result2;
          retrunHtml = retrunHtml.replace(match[0],"");
        }
        let result3 = regex3.exec(tempHtml3); 
        if(result3 != null){
          match = result3;
          retrunHtml = retrunHtml.replace(match[0],"");
        }
        let result4 = regex4.exec(tempHtml3); 
        if(result4 != null){
          match = result4;
          retrunHtml = retrunHtml.replace(match[0],"");
        }
        let result5 = regex5.exec(tempHtml3); 
        if(result5 != null){
          match = result5;
          retrunHtml = retrunHtml.replace(match[0],"");
        }  
      }

      return retrunHtml;
    },
    txtEmoticonDelYn(e) {
      if(this.tenantId == '203'){
        if(document.querySelector(".txtEmoticonAdd .txtAddEmoticon") == null) {
        document.querySelector(".txtEmoticon").classList.remove('hide')
      }
      }

    },
    txtEmoticonModiDelYn(e,type,commentId) {
      if(this.tenantId == '203'){
        if(type == 'addUpdate'){
          if(document.querySelector(".emoUpdate"+commentId + " .txtAddEmoticon") == null) {
            document.querySelector(".txtEmoticonUpdate" + commentId).classList.remove('hide')
          }
        }else if(type == 'addReply'){
          if(document.querySelector(".textarea.editor"+commentId + " .txtAddEmoticon") == null){
            document.querySelector(".txtReplyEmoticon" + commentId).classList.remove('hide');
          }
        }else{
          if(document.querySelector(".textarea.editor.reply.ediEmo"+commentId + " .txtAddEmoticon") == null){
            document.querySelector(".replyEmoticonUpdate" + commentId).classList.remove('hide');
          }
        }
      }


    },
    createFindKey(){
      let res = [];
      this.HW_KEYGEN({head: "CMEX", res});
      let callFindKey = res[0];

      return callFindKey;
    },
    opinionPlaceholder(useEmoticon) {
      console.log("의견란");
      let txt = '';
      if(useEmoticon){
        txt = this.$i18nUtil.trans("message.placeholder.reply","이모티콘을 등록하거나 답변 입력 후 @사용자이름'으로 대상자를 호출해보세요.")
      } else {
        txt = this.$i18nUtil.trans("message.ProjectComment.009","답변을 입력하고 @사용자이름으로 대상자를 지정하세요")
      }
      return document.querySelector('.textarea.txtEmoticonAdd').innerHTML.length > 0 ? '' : txt ;
    }
  }
};
</script>
<style scoped>
.btn-txt-underline.reply {
  margin-top: 13px;
}
.opinion_box .txt {
  word-break: break-all;
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/comment/BoardComment.vue